import * as React from 'react';
import { useLayoutEffect, useEffect } from 'react';
import CheckoutSteps from './Checkout/CheckoutSteps/CheckoutSteps';
import CheckoutTotal from './Checkout/CheckoutItemInfo/CheckoutTotal';
import SystemAlerts from 'src/component/SystemAlerts';
import useReduxState from 'src/hooks/useReduxState';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import { useSelector } from 'react-redux';
import AlertContentWithFlag from './Checkout/AlertContentWithFlag';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { event } from "src/store/slice/system";
import store from "src/storeWire";
import { useState } from 'react';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { QuoteCartHeader } from './QuoteCart/QuoteCartHeader';
import ReusableDiv from 'src/support/ReusableDiv';
import Order from "@system/config/order";
import CartRepository from 'src/repository/CartRepository';
import { __set, __remove } from 'src/store/axios_indicator';
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';

export function Checkout() {
    const [_check_p] = useCheckAuthPermissions();
    const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();
    const [{  get_current_quote_cart }, { }, {  }] = useQuoteDetailStore(); 
    const [isPaymentBlocked] = useReduxState('', 'setIsPaymentBlocked');
    const [isCreditRisk] = useReduxState('', 'setIsCreditRisk');
    const [isPlaceOrder] = useReduxState('', 'setIsPlaceOrder');
    const [isPONumber] = useReduxState('', 'setIsPONumber');
    const [isTermsCondition] = useReduxState('', 'setIsTermsCondition');
    const [invoiceMsgErr] = useReduxState(false, 'setInvoiceMsgErr');
    const [isCreditRiskAlert] = useReduxState('', 'setCreditRiskAlert')
    const [isOrderError] = useReduxState('', 'setIsOrderError');
    const [__check] = useAxiosIndicatorCheck();
    const placeOrderLoading = useSelector((state) => state.entities.model_Order.placeOrderLoading);
    const [isOrderPlaced, setOrderPlaced] = useState(false)
    const from = sessionStorage.getItem("successUrl")?.includes("order-confirm");
    const [isHazardous,setIsHazardous] = useState(false);
    const quoteNumber = System.getParams().quote_number;
    const [{ CART_DATA }, {}, {}] = useCartStore();
    const quoteList = get_current_quote_cart();
    /**
     * Author: Trilok
     * Date: 14-02-2023
     * Reason: user can't back to order placed page
     */
    useLayoutEffect(() => {

        if (from) {
            window.location.href = Order.getOrderHistoryRouteURL();
        }

        if (window.location.search.length > 1) {
            // nothing
        } else {
            setOrderPlaced(false)
        }
    }, [])

    useEffect(() => {
        let bodyElem = document.getElementsByTagName("BODY")[0];
        if (__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status) {
            if (bodyElem !== undefined) {
                if (bodyElem.hasAttribute('id') && bodyElem.getAttribute('id').includes('checkoutloader') === false) {
                    bodyElem.setAttribute('id', bodyElem.getAttribute('id') + ' checkoutloader')
                }
                else {
                    bodyElem.setAttribute('id', 'checkoutloader')
                }
            }
        }
        else {
            if (bodyElem !== undefined && bodyElem.hasAttribute('id') && bodyElem.getAttribute('id').includes('checkoutloader')) {
                bodyElem.setAttribute('id', bodyElem.getAttribute('id').replace('checkoutloader', ''))
            }
        }
    }, [__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status])

    /**
     * Author : Pankaj
     * Date   : 08-08-2023
     * Reason : Hide DX Loader once our component loads.
     */
    useEffect(() => {
        if (document.getElementsByClassName('snippet') && document.getElementsByClassName('snippet').length > 0) {
            document.getElementsByClassName('snippet')[0].style.display= 'none';
        }
    }, [])

    useEffect(() => {
        if (window?.digitalData) {
            window.digitalData.event.eventinfo.events = `Checkout clicked from ${quoteNumber ? ' Quote Cart':' My Cart'}`;
        }
    }, [window?.digitalData?.event])

    useEffect(() => {
        const isHazardous = 
            Object.values(quoteList || {}).some(item => item?.product?.HazardousFlag?.toLowerCase() === 'yes') || 
            (CART_DATA?.length >0 && CART_DATA?.some(x => x?.hazardousFlag?.toLowerCase() === 'yes'));
        setIsHazardous(isHazardous);
    }, [CART_DATA, quoteList]);
    
    return (
        <>
            {(__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status && isOrderPlaced) ? <AxiosIndicatorRunTimeLoader overlay />
                : (_check_p('CKOT_VIEW').status && !from &&
                    <div>
                        {/* <QuoteCartHeader /> */}

                        <div className="checkout-process pt-3">
                            <div className="container">
                            {/**
                             * Ticket #  : 12945
                             * Change #  : Removed 3 dots after placing order
                             * Change by : Pankaj
                             * Date      : 16 Aug,2023   
                             */
                            }
                            {/* {placeOrderLoading ? <AxiosIndicatorRunTimeLoader overlay /> : null} */}
                            {placeOrderLoading &&
                                <div className="loader-wrapper loader-wrapper-fixed">
                                </div>
                            }

                                <div className="bs5 row">
                                    <div className='col-12'>
                                        {isPaymentBlocked === true && isPlaceOrder === true &&
                                            <AlertContentWithFlag message={'Unable to place the order, please Contact your Account Representative.'} type="danger" isDisplay={false} isDisplayIcon={true} />
                                        }

                                        {isPaymentBlocked === 'close' && isPlaceOrder === true &&
                                            <AlertContentWithFlag message={'We are having trouble processing your order request. There can be various reasons as to why, please reach out to your local Sales Representative (indicated under My Contacts, on your Dashboard).'} type="danger" isDisplay={false} isDisplayIcon={true} />
                                        }

                                        {isCreditRisk === true && isCreditRiskAlert === true && isPlaceOrder === true &&
                                            <AlertContentWithFlag message={'Payment in advance required.'} type="warning" isDisplay={true} isDisplayIcon={false} />
                                        }

                                        {isPONumber === true &&
                                            <AlertContentWithFlag message={'Error! You must enter a <b>Purchase Order Number</b> before placing your order.'} type="danger" isDisplay={false} isDisplayIcon={true} />
                                        }
                                        {isTermsCondition === true &&
                                            <AlertContentWithFlag message={'Error! You must acknowledge the <b>Terms and Conditions</b> before placing your order'} type="danger" isDisplay={false} isDisplayIcon={true} />
                                        }
                                        {invoiceMsgErr === true &&
                                            <AlertContentWithFlag message={'Please select invoice address to proceed'} type="danger" isDisplay={false} isDisplayIcon={true} />
                                        }
                                        {(latest_system_notification_data.errorModule !== undefined && latest_system_notification_data.errorModule !== 'checkoutCart') &&
                                            <SystemAlerts />
                                        }
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
                                        <CheckoutSteps />
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                                        <CheckoutTotal />
                                        {/* <CheckoutItemInfo /> */}
                                        {isHazardous && ReusableDiv.CheckoutItemInfo()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)
            }
        </>
    );

}
